export default {
  fonts: {
    body: 'ballinger, sans-serif',
    heading: 'Space Grotesk, sans-serif'
  }
}
